import { EInvoicingAddressingLine } from '@features/eInvoicing/types/eInvoicingAddressingLine'

import { isActiveAddressingLine } from './isActiveAddressingLine'
import { normalizeAddressingLine } from './normalizeAddressingLine'

export const getMatchedAddressingLine = (
  addressingLines: EInvoicingAddressingLine[],
  addressingLine?: string,
): EInvoicingAddressingLine | undefined => {
  const normalizedAddressingLine = normalizeAddressingLine(addressingLine ?? '').toLowerCase()

  return addressingLines.find(
    (line) =>
      normalizeAddressingLine(line.addressingLine).toLowerCase() === normalizedAddressingLine &&
      isActiveAddressingLine(line),
  )
}
